import { resetRoadmap, setSingleRoadmap } from "../redux/slices/roadmap";
import { resetTimelineStateFromStrategyMap } from "../redux/slices/timeline";
import store from "../redux/store";
import { StrategyMapListItem } from "../services/strategyMap";
import { newPath } from "./newPath";

export type smapBreadCrumbHistoryType = {
  name: string;
  url: string;
}[]

export const smapNavigateToEntity = (entity: StrategyMapListItem) => {
    store.dispatch(resetTimelineStateFromStrategyMap());
    store.dispatch(resetRoadmap());
    store.dispatch(setSingleRoadmap({}));
    const entity_type = entity.type == "roadmap" ? "roadmaps" : "projects";
    return(`/${entity_type}/${entity.id}`);
    }

export const smapNavigationLinkBuilder = (current_name:string | null, entity: {type:string, id:string})=>{

     store.dispatch(resetTimelineStateFromStrategyMap());
     store.dispatch(resetRoadmap());
     store.dispatch(setSingleRoadmap({}));


       const currentUrl = location.pathname + location.search;
                const newHistory:smapBreadCrumbHistoryType = [
                  { name: "Strategy Map", url: "/strategymaps" },

                  ...(current_name ? [{name: current_name, url: currentUrl}] : []),
                 
                ];
                const path = (entity.type == "roadmap" ? `/roadmaps/${entity.id}` : `/projects/${entity.id}`);
    
                return newPath(path, {history: JSON.stringify(newHistory)});
}